import { apiClient } from "@/config/api";
import { ApiResponse } from "@/types/status";

// PhimAPI Types
export interface PhimApiMovie {
  _id: string;
  name: string;
  slug: string;
  origin_name: string;
  poster_url: string;
  thumb_url: string;
  year: number;
  type: string;
  status?: string;
  episode_current?: string;
  quality?: string;
  lang?: string;
  category?: Array<{ id: string; name: string; slug: string }>;
  country?: Array<{ id: string; name: string; slug: string }>;
}

export interface PhimApiListPagination {
  totalItems: number;
  totalItemsPerPage: number;
  currentPage: number;
  totalPages: number;
}

export interface PhimApiListResponse {
  status: string;
  items: PhimApiMovie[];
  pagination: PhimApiListPagination;
}

export interface PhimApiMovieDetail {
  _id: string;
  name: string;
  slug: string;
  origin_name: string;
  content: string;
  type: string;
  status: string;
  poster_url: string;
  thumb_url: string;
  year: number;
  actor: string[];
  director: string[];
  category: Array<{ id: string; name: string; slug: string }>;
  country: Array<{ id: string; name: string; slug: string }>;
  episode_current: string;
  episode_total: string;
  time: string;
  quality: string;
  lang: string;
}

export interface PhimApiDetailResponse {
  status: boolean;
  msg: string;
  movie: PhimApiMovieDetail;
  episodes: Array<{
    server_name: string;
    server_data: Array<{
      name: string;
      slug: string;
      filename: string;
      link_embed: string;
      link_m3u8: string;
    }>;
  }>;
}

export interface GetPhimApiListParams {
  page?: number;
  limit?: number;
  sort_field?: string;
  sort_type?: string;
  category?: string;
  country?: string;
  year?: string;
}

export interface BulkPhimApiResult {
  success: Array<{
    slug: string;
    kkmovieId: string;
    articleId: string;
    title: string;
  }>;
  failed: Array<{ slug: string; error: string }>;
  skipped: Array<{ slug: string; reason: string }>;
}

export interface SearchPhimApiParams {
  keyword: string;
  page?: number;
  sort_field?: string;
  sort_type?: string;
  sort_lang?: string;
  category?: string;
  country?: string;
  year?: string;
  limit?: number;
}

const PHIMAPI_ENDPOINTS = {
  LIST: (type: string) => `/kkphim-sync/phimapi/list/${type}`,
  SEARCH: "/kkphim-sync/phimapi/search",
  MOVIE: (slug: string) => `/kkphim-sync/phimapi/movie/${slug}`,
  BULK_CREATE: "/articles/bulk-phimapi",
} as const;

export const phimApiService = {
  // Lấy danh sách phim từ PhimAPI (qua backend proxy)
  getMovieList: async (
    type: string,
    params: GetPhimApiListParams = {}
  ): Promise<ApiResponse<PhimApiListResponse>> => {
    return await apiClient.get(PHIMAPI_ENDPOINTS.LIST(type), params as any);
  },

  // Tìm kiếm phim từ PhimAPI (qua backend proxy)
  searchMovies: async (
    params: SearchPhimApiParams
  ): Promise<ApiResponse<PhimApiListResponse>> => {
    return await apiClient.get(PHIMAPI_ENDPOINTS.SEARCH, params as any);
  },

  // Lấy chi tiết phim từ PhimAPI (qua backend proxy)
  getMovieDetail: async (
    slug: string
  ): Promise<ApiResponse<PhimApiDetailResponse>> => {
    return await apiClient.get(PHIMAPI_ENDPOINTS.MOVIE(slug));
  },

  // Import và tạo articles từ danh sách slugs
  createBulkFromPhimApi: async (
    slugs: string[]
  ): Promise<ApiResponse<BulkPhimApiResult>> => {
    return await apiClient.post(PHIMAPI_ENDPOINTS.BULK_CREATE, { slugs });
  },
};
